module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAA3NCSVQICAjb4U/gAAAAMFBMVEX///////////////////////////////////////////////////////////////9Or7hAAAAAEHRSTlMAESIzRFVmd4iZqrvM3e7/dpUBFQAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAB6SURBVBiVY2AgCrC4CDAwujiAmIzv/wcwsP7/JwBksz8SBJKCegkg9gGwSp4CNDZLAffdu3c3sDtATBIUFIQwGI0hAGQOyyoIcECzllGAvaOjo4ARbNcBltDQUAcM89kvgNm8YLt+zjRgYJ45H2xO9W4HBpbd24jzIADXRiFoxOg+kwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/side4.png
// module id = EGoQ
// module chunks = 1